<template>
    <div>
        <label class="block mb-2 font-medium" :for="`field_${field.id}`">{{field.label}}<span class="text-bold inline-block ml-2" v-if="field.isRequired" title="This field is required" aria-hidden="true">*</span></label>

        <v-select
            tabindex="0"
            v-if="reasons.length"
            :options="reasons"
            :id="`field_${field.id}`"
            label="post_title"
            v-model="selected_reason"
            :required="field.isRequired"
        ></v-select>
        <input
            tabindex="0"
            v-else
            type="text"
            :id="`field_${field.id}`"
            label="post_title"
            v-model="selected_reason"
            :required="field.isRequired"
            class="border border-solid border-black w-full p-4"
        >
    </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
    computed: {
        reasons() {
            if(this.field.choices) {
                return this.field.choices.map(choice => ({ post_title: choice.text, value: choice.value }));
            }
            if(typeof window.departments[this.$store.state.data.service] != 'undefined') {
                return window.departments[this.$store.state.data.service]['services'];
            }

            return [];
        },
        selected_reason: {
            get() {
                return this.$store.state.data.reason;
            },
            set(val) {
                this.$store.commit('updateData', {
                    field: this.field.id,
                    value: val
                });
            }
        }
    },
    components: {
        vSelect
    },
    props: ['field']
}
</script>